import 'videojs-titleoverlay';

export default {
  mapPropStateToOptions: ({ title }) => ({
    title,
    floatPosition: 'right',
    margin: '0px',
    fontSize: '16px',
    debug: false,
  }),
};
